import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromCOM from './reducers/com.reducer';

// Root state interface
export interface AppState {
  com: fromCOM.State;
  // Add other feature states here as you create them
}

// Root reducers
export const reducers: ActionReducerMap<AppState> = {
  com: fromCOM.Reducer
  // Add other reducers here
};

// Meta-reducers for development (like logging)
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
